import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Menu } from "antd";
import styled from "styled-components";

import Service from "../../service/_Master";

const { SubMenu } = Menu;

const NavBarMenu = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  & > .navbar-menu__link-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
`;
const AntMenu = styled(Menu)`
  background: transparent;
  border-bottom: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border: none;
  list-style-type: none;
  padding-top: 10px;

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {
    border: none;
  }

  &.ant-menu-horizontal > .ant-menu-item::after,
  &.ant-menu-horizontal > .ant-menu-submenu::after {
    transition: none;
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item {
    padding: 0px 10px;
    margin-left: 10px;
  }
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  }

  & > .ant-menu-item {
    border-bottom: none;
    opacity: 1 !important;

    :hover {
      border: none !important;
    }
  }

  .ant-menu-item-selected {
    a {
      border-bottom: 1.5px solid #007bff;
    }
  }
  /* &.ant-menu-submenu-active .ant-menu-submenu-selected */
  &.ant-menu-light .ant-menu-submenu-selected{
    .ant-menu-title-content span {
        padding: 6px 0px;
        border-bottom: 1.5px solid #007bff;
      }
  }
  &.ant-menu-light .ant-menu-submenu-active:not(.ant-menu-submenu-selected) {
    color: #000;
    border: none;

    &:not(.ant-menu-submenu-open) {
      .ant-menu-title-content span {
        border: none;
      }
    }

    &.ant-menu-submenu-open {
      color: #007bff;
      .ant-menu-title-content span {
        padding: 6px 0px;
        border-bottom: 1.5px solid #007bff;
      }
    }
  }

  &.ant-menu-light .ant-menu-submenu-active.ant-menu-submenu-selected{
      .ant-menu-title-content span {
        padding: 6px 0px;
        border-bottom: 1.5px solid #007bff;
      }
  }

  /* .ant-menu-overflow-item-rest{ display: none;} */

  @media only screen and (max-width: 767.9px) {
    position: absolute;
    text-align: center;
    background-color: #fff;
    top: 70px;
    z-index: 9999;
    border: 1px solid lightgray !important;
    padding: 0px;
    width: 100vw;
    right: ${(props) => (props.expanded == "true" ? "-20px" : "-2000%")};
    transition: all 0.2s;

    & > .ant-menu-item {
      min-height: 50px;
    }
    &.ant-menu-vertical .ant-menu-item:not(:last-child),
    &.ant-menu-vertical-left .ant-menu-item:not(:last-child),
    &.ant-menu-vertical-right .ant-menu-item:not(:last-child),
    &.ant-menu-inline .ant-menu-item:not(:last-child) {
      margin: 0px;

      &.ant-menu-item-selected {
        a{ border: none;}
      }
    }

    & > .ant-menu-item:hover:not(:last-child),
    & > .ant-menu-item-active,
    & > .ant-menu-item:not(:last-child) {
      border-bottom: 1px solid lightgray !important;

      a:hover {
        border: none;
      }
    }

    &.ant-menu-vertical .ant-menu-submenu,
    &.ant-menu-vertical-left .ant-menu-submenu,
    &.ant-menu-vertical-right .ant-menu-submenu,
    &.ant-menu-inline .ant-menu-submenu {
      width: 100%;

      .ant-menu-item-selected {
        a {
          border-bottom: none;
        }
      }

      .ant-menu-title-content {
        text-align: center;
      }
    }
  }
`;
const NavBarLink = styled(NavLink)`
  text-decoration: none;
  color: #000;
  padding: 6px 0px;

  &:hover {
    text-decoration: none;
    border-bottom: 1.5px solid #007bff;
  }
`;

export default function MenuLink(props) {
  const path = useSelector((state) => state.master.path);
  const [menu, setMenu] = useState([]);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const email = useSelector((state) => state.acc.email);

  window.addEventListener("resize", () => {
    setWindowSize(window.innerWidth);
  });

  useEffect(() => {
    const init = async () => {
      let menus = await Service.getMenus();
      setMenu(menus);
    };

    init();
  }, []);

  const fetchSubMenu = (list, parentsPath) => {
    return list.map((subMenu, index) => {
      let path =
        parentsPath === "/" ? subMenu.path : parentsPath + subMenu.path;
      return (
        <Menu.Item key={path} onClick={props.fncToggleNavBar}>
          <NavBarLink to={path}>{subMenu.disp_name}</NavBarLink>
        </Menu.Item>
      );
    });
  };

  const fetchMenu = menu.map((menu, index) => {
    return menu.sub.length > 0 ? (
      <SubMenu key={menu.path} title={<span>{menu.disp_name}</span>}>
        {fetchSubMenu(menu.sub, menu.path)}
      </SubMenu>
    ) : (
      <Menu.Item key={menu.path} onClick={props.fncToggleNavBar}>
        <NavBarLink to={menu.path}>{menu.disp_name}</NavBarLink>
      </Menu.Item>
    );
  });

  return (
    <div
      className={"menu-link" + (props.className ? props.className : "")}
      style={{ width: "100%" }}
    >
      <NavBarMenu className="navbar-menu__link">
        <div className="navbar-menu__link-container">
          <AntMenu
            defaultSelectedKeys={[`${path}`]}
            selectedKeys={[`${path}`]}
            mode={windowSize >= 768 ? "horizontal" : "inline"}
            expanded={props.expanded ? "true" : "false"}
          >
            {/* {(email ? <> </> : fetchMenu)} */}
            {fetchMenu}
          </AntMenu>
        </div>
      </NavBarMenu>
    </div>
  );
}
